import { Text } from '@doist/marketist';
import cn from 'clsx';
import CondensedIcon from './condensed-icon.svg';
import css from './product-ui-weekly-calendar-all-day-info.module.css';
export type ProductUIWeeklyCalendarAllDayInfoProps = {
  text: string;
  withTaskCollapseIcon?: boolean;
};
export function ProductUIWeeklyCalendarAllDayInfo({
  text,
  withTaskCollapseIcon
}: ProductUIWeeklyCalendarAllDayInfoProps) {
  return <div className={cn(css.weeklyCalendarAllDayInfo, {
    [css.withTaskCollapseIcon]: withTaskCollapseIcon
  })} data-sentry-component="ProductUIWeeklyCalendarAllDayInfo" data-sentry-source-file="product-ui-weekly-calendar-all-day-info.tsx">
            {withTaskCollapseIcon && <CondensedIcon width={14} height={10} />}
            <Text size="body-2xs" weight="semibold" data-sentry-element="Text" data-sentry-source-file="product-ui-weekly-calendar-all-day-info.tsx">
                {text}
            </Text>
        </div>;
}